import Cookies from 'js-cookie'
import { fbLoginCookie, userSessionCookie } from './auth.constants'
import { AuthProviderFactory, getCvUserFromIdToken } from 'react-ai-platform-auth'
import { ICvUser, ICvUserExtended } from './auth.types'
import { authConfig } from './auth.config'

export const getBearerToken = () => {
    try {
        return `Bearer ${JSON.parse(Cookies.get(userSessionCookie) ?? '').token}`
    } catch {
        console.log('not authorized')
        const redirectUrl = authConfig.defaultLogoutRedirectUrl
        window.location.replace(redirectUrl)
    }
    return null
}

export const deleteLocalSession = () => {
    Cookies.remove(userSessionCookie)
    Cookies.remove(fbLoginCookie)
}

export function transformCvUser(input: ICvUserExtended | null): ICvUser | null {
    if (input === null) {
        return null
    }
    return {
        first_name: input.firstName ?? '',
        is_activated: input.isActivated,
        last_name: input.lastName ?? '',
        organizations: [{ id: input.organizations.id, org_type: input.organizations.org_type }],
        rbac2_roles: input.rbac2Roles.map(role => role),
        require_mfa: input.requireMfa,
        roles: input.roles.map(role => role),
        state: input.state,
        status: input.status,
        token: input.token,
        user_id: input.userId,
        email: input.email,
    }
}

export function getCvUserFromIdTokenExtended(idToken: string): ICvUserExtended | null {
    const user = getCvUserFromIdToken(idToken) as ICvUserExtended
    return user || null
}

export const { AuthProvider, Authenticate, Authorize, withAuthorize, useAuthContext } =
    AuthProviderFactory(getCvUserFromIdTokenExtended)
